module.exports = __webpack_public_path__ + "img/rating-background-mobile.25f61c7a.svg";